import { AUTOMATION_PLATFORM_FLOW_TYPE_ID, MARKETING_EMAIL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import CommentObjectType from './CommentObjectType';
import { COMMENT_ONBOARDING_TOUR_ID, FLOATING_SIDEBAR_TOUR_ID } from './tourIDs';
import { getCommentingObjectType } from '../utils/commentingUtils';
const floatingSidebarTourBlockList = [getCommentingObjectType(CommentObjectType.REPORTING_DASHBOARD), getCommentingObjectType(AUTOMATION_PLATFORM_FLOW_TYPE_ID), getCommentingObjectType(MARKETING_EMAIL_TYPE_ID)];
const onboardingTourBlockListedObjectTypes = {
  [FLOATING_SIDEBAR_TOUR_ID]: floatingSidebarTourBlockList,
  [COMMENT_ONBOARDING_TOUR_ID]: []
};
export default onboardingTourBlockListedObjectTypes;